import StyledInput from './StyledInput';

export default StyledInput;
